<template>
    <el-container id="app" class="container">
        <el-header>
            <my-header></my-header>
        </el-header>
        <el-main>
            <div class="layout w1200">
                <router-view></router-view>
            </div>
            <div class="top-btn" @click="goTop()"><i class="el-icon-caret-top"></i></div>
        </el-main>
        <my-footer></my-footer>
        <Login v-if="s_getLoginModal"></Login>
    </el-container>
</template>

<script>
    import myHeader from "@components/common/header.vue";
    import myFooter from "@components/common/footer.vue";
    import Login from "@components/common/login.vue";
    import {
        mapGetters,
        mapMutations
    } from "vuex";
    export default {
        name: "app",
        components: {
            myHeader,
            myFooter,
            Login,
        },
        data() {
            // 这里存放数据
            return {};
        },
        created() {
            this.getAbout();
        },
        mounted() {
            this.getConfig();
            this.$y_setKey("lon", "113.320234");
            this.$y_setKey("lat", "23.022241");
            // this.getUserInfo();

        },
        watch: {},
        // 监听属性 类似于data概念
        computed: {
            ...mapGetters(["s_getLoginModal"]),
        },
        // 方法集合
        methods: {
            ...mapMutations(["s_setUser"]),
            async getConfig() {
                let {
                    data
                } = await this.$y_ajax("api/member/config");
                this.$y_setKey("config", data);
                if (data.oss_switch == 1 && data.Endpoint && data.Bucket) {
                    let url = "//" + data.Bucket + "." + data.Endpoint;
                    this.$y_setKey("imgurl", url);
                }
            },
            async getUserInfo() {
                if (this.$y_getKey("userid") && this.$y_getKey("token")) {
                    let result = await this.$y_getUser();
                    if (result) {
                        this.s_setUser(result);
                    }
                }
            },
            goTop() {
                document.querySelector("html").scrollTop = 0;
            },
            async getAbout() {
                let {
                    code,
                    data
                } = await this.$y_ajax("api/help/question", {
                    cid: 7,
                });
                if (code == 200) {
                    data.forEach((v) => {
                        v.content = "";
                    });
                    this.$y_setKey("about", data);
                    this.aList = data;
                }
            },
        },
    };
</script>
<style>
    ul,
    li {
        list-style: none;
    }

    .el-header {
        height: auto !important;
    }


    .container {
        height: 100%;
        min-width: 1200px;
    }

    .layout {
        min-height: 60vh;
    }

    .page-box {
        padding-bottom: 15px;
        text-align: right;
    }

    .big-title {
        padding: 15px;
        background: #f3f3f3;
    }

    .flex {
        display: flex;
        align-items: center;
    }

    .flex-c {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flex-a {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .flex-w {
        display: flex;
        flex-wrap: wrap;
    }

    .flex-bt {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .flex-start {
        display: flex;
        justify-content: flex-start;
    }

    .flex-end {
        display: flex;
        justify-content: flex-end;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    /* 省略 */
    .ellipsis-1 {
        display: -webkit-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal !important;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .ellipsis-2 {
        display: -webkit-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal !important;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .ellipsis-3 {
        display: -webkit-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal !important;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    /* 头像 */
    .tx {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }

    /* 头部 城市弹窗 */
    .city-box.el-popover {
        background: transparent;
        border: 0;
        box-shadow: none;
        padding: 0;
        margin-top: 0;
    }

    .top-btn {
        right: 10px;
        bottom: 50px;
        position: fixed;
        background: #fff;
        box-shadow: 0 2px 2px #aaa;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .top-btn .el-icon-caret-top {
        font-size: 30px;
        color: #cd7dfe;
    }

    @media (max-width: 600px) {
        .container {
            width: 100%;
            min-width: auto;
        }
    }
</style>